<template>
  <div>
    <div class="header-wrapper">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="">
          <el-input v-model="formInline.name" placeholder="路由名称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="success" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="addBtn" icon="el-icon-plus" @click="onNew">新增</el-button>
        </el-form-item>
      </el-form>
       <!-- 新增/修改路由 -->
      <el-dialog :visible.sync="dialog" width="40%">
        <div slot="title">{{formTitle}}</div>
        <el-form :model="form" :rules="rules" ref="form">
          <el-form-item label="路由名称" :label-width="formLabelWidth" prop="name">
            <el-input type="text" v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="路由列表" :label-width="formLabelWidth" prop="detail">
            <el-input :autosize="{ minRows: 5, maxRows: 15}" type="textarea" v-model="form.detail" placeholder="请输入路由列表"></el-input>
          </el-form-item>
          <el-form-item label="优先级" :label-width="formLabelWidth" prop="priority">
            <el-input type="text" v-model="form.priority"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialog = false">取 消</el-button>
          <el-button v-if="isEditor" type="primary" @click="handleModify('form')">修 改</el-button>
          <el-button v-else type="primary" :loading="vloading.newLoading" @click="handleSubmit('form')">新 增</el-button>
        </div>
      </el-dialog>
    </div>
  <div class="main-content">
    <el-table
        v-loading="loading"
        element-loading-text="拼命加载中"
        :data="tableData"
        stripe
        border
        style="width:100%"
        >
        <el-table-column prop="priority" label="优先级" align="center" width="80"></el-table-column>
        <el-table-column prop="name" label="路由名称" align="center" width="120"></el-table-column>
        <el-table-column prop="detail" label="功能列表"></el-table-column>
        <el-table-column prop="id" label="ID序号" align="center" width="80"></el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="修改" placement="bottom">
              <span
              class="el-icon-edit-outline"
              size="mini"
              @click="handleEdit (scope.row)"></span>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
              <span
              class="el-icon-delete"
              size="mini"
              type="danger"
              @click="handleDelete (scope.$index, scope.row)"></span>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
  </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import AUTH from 'api/api_authority'

export default {
  name: 'MainContent',
  props: {
    surveyInfo: Array,
    loading: Boolean
  },
  data () {
    return {
      vloading: {
        newLoading: false
      },
      dialog: false,
      formTitle: '新增路由',
      isEditor: false,
      articleLoading: false,
      form: {
        id: '',
        name: '',
        detail: '',
        priority: ''
      },
      formInline: {
        name: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入路由名称', trigger: 'blur' },
          { min: 1, max: 64, message: '长度在 1 到 64 个字符', trigger: 'blur' }
        ],
        detail: [
          { required: true, message: '请输入路由列表', trigger: 'blur' }
        ],
        priority: [
          { required: true, message: '请输入显示优先级', trigger: 'blur' }
        ]
      },
      formLabelWidth: '80px'
    }
  },
  computed: {
    tableData () {
      return this.surveyInfo
    },
    ...mapState(['token'])
  },
  methods: {
    onNew () {
      this.dialog = true
      this.isEditor = false
      this.vloading.newLoading = false
      this.formTitle = '新增路由'
      this.form.name = ''
      this.form.detail = ''
      this.form.priority = ''
    },
    // 修改
    handleEdit (row) {
      let that = this
      this.isEditor = true
      this.dialog = true
      that.formTitle = '修改路由'
      that.form = Object.assign({}, row)
    },
    // 新增
    handleSubmit (form) {
      let that = this
      this.$refs[form].validate((valid) => {
        if (valid) {
          that.vloading.newLoading = true
          AUTH.createOne(that.form).then((res) => {
            if (res.code === 0) {
              that.vloading.newLoading = false
              this.$message({
                message: '恭喜你，新增成功',
                type: 'success'
              })
              that.dialog = false
              that.$emit('refresh')
            } else {
              this.$message({
                message: res.msg,
                type: 'warning'
              })
            }
          })
        } else {
          return false
        }
      })
    },
    // 修改
    handleModify (form) {
      let that = this
      this.$refs[form].validate((valid) => {
        if (valid) {
          AUTH.upDate(that.form).then((res) => {
            if (res.code === 0) {
              this.$message({
                message: '恭喜你，修改成功',
                type: 'success'
              })
              that.dialog = false
              for (var name in this.$data.form) {
                if (Array.isArray(this.$data.form[name])) {
                  this.$data.form[name] = []
                } else {
                  this.$data.form[name] = ''
                }
              }
              that.$emit('refresh')
            } else {
              this.$message({
                message: res.msg,
                type: 'warning'
              })
            }
          })
        } else {
          return false
        }
      })
    },
    // 删除数据
    handleDelete (index, row) {
      let that = this
      let id = row.id
      this.$confirm('此操作将永久删除该列内容, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        AUTH.delete(id).then((res) => {
          if (res.code === 0) {
            that.$emit('delete', index)
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
          } else {
            this.$message.error('删除失败 ' + res.msg)
          }
        })
      }).catch(() => {
        return false
      })
    },
    // 点击搜索传值到父组件
    onSubmit () {
      this.$emit('search', this.formInline)
    }
  }
}
</script>

<style lang="stylus" scoped>
.main-content >>> .el-input
  width 400px
.main-content >>> .el-form-item
  .el-textarea
    width 400px
.main-content >>> .el-form-item__error
  top: 10px
  left: 310px
.main-content >>> .el-tag
  height 25px
  line-height 25px
.header-wrapper >>> .el-dialog__header
  background-color #4fa0ea
  color white
  line-height 20px
  padding-top 10px

.main-content
  width 100%
  .el-icon-edit-outline
    color #409EFF
    font-size 20px
    margin-right 5px
    cursor pointer
  .el-icon-delete
    color #F56C6C
    font-size 20px
    cursor pointer
  .class
    cursor pointer
  .detail
    margin-right 5px
    color #67C23A
    font-size 20px
    cursor pointer
  .demo-table-expand
    font-size 0
    label
      width 90px
      color #99a9bf
    .el-form-item
      margin-right 0
      margin-bottom 0
</style>
<style type="text/css">
  .el-select {
    width: 100%
  }
  .el-form-item__error {
    color: #f56c6c;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    position: absolute;
    top: 100%;
    left: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/authority/components/MainContent.vue